module.exports = __webpack_public_path__ + "images/ic_grade_white_24px.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ic_grade_white_24px.svg
 ** module id = 60
 ** module chunks = 1
 **/